import { ca } from '@cian/analytics';

export function trackView() {
  ca('event', {
    action: 'flats_otherFloors_show',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function suburbanTrackView(id: number) {
  ca('eventSite', {
    action: 'show_multioffer_link',
    category: 'Card',
    label: '',
    event: 'soprevent',
    products: [
      {
        id,
        offerType: 'KP',
        position: 1,
      },
    ],
  });
}

export function trackClick() {
  ca('event', {
    action: 'flats_otherFloors_click',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function suburbanTrackClick(id: number) {
  ca('eventSite', {
    action: 'to_multioffer_listing',
    category: 'Card',
    name: 'oldevent',
    products: [
      {
        id,
        offerType: 'KP',
        position: 1,
      },
    ],
  });
}
